import { createApiDescription } from "../../helperFunctions";

export const officeLocationInfo = {
    allLocation: createApiDescription(
        "This API can be called to get the list of office Locations with various filters applied in the request.",
        [
            "Office Location API provide results based on the given filters on the request headers and if no filter values are given, it provides results based on default value mapped with all filters.",
            "The default number of returns in the response will be 10.",
            "By default, the primary office location will be displayed first in the response if no filters are applied."
        ]
    ),
    locationById: createApiDescription(
        "This API can be called to get the office location details for the given office location id.",
        [
            "Office Location ID is what is returned from our APIs that return office location."
        ]
    ),
}